import React from 'react';
import styled from '@emotion/styled';

import theme from '../theme';

const StyledLabel = styled.div`
  line-height: 1.5;
  font-size: ${theme.componentFontSize};
  font-weight: bold;
  color: ${theme.colorsBlack};
`;

export interface LabelProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export default function Label({ className, style, children }: LabelProps) {
  return (
    <StyledLabel className={`ant-label ${className}`} style={style}>
      {children}
    </StyledLabel>
  );
}
